import React, {Component} from 'react';
import {Row, Col, Table, Layout} from 'antd';
import {Link} from 'react-router-dom';
import moment from 'moment';
import Head from '../components/Head';
import '../css/rescue.css';
import {api, app} from "../app";
import utils from "../utils";

const {Header, Footer, Content} = Layout;
class TrainList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data_loading: true,
            trainList: []
        };
        this.dataSource();
    }

    /**
     * 数据源
     */
    dataSource() {
        const _this = this;
        app.post(api.TrainList).then(({flag, data, msg}) => {
            if (flag === 1) {
                _this.setState({trainList: utils.addArrayKey(data)});
            } else {
                app.alert("网络服务忙~", "error");
            }
            _this.setState({data_loading: false});
        });
    }

    render() {
        const columns = [
                {
                    title: '培训名称',
                    dataIndex: 'trainame',
                    key: 'trainame',
                    width: '35%'
                },
                {
                    title: '培训级别',
                    dataIndex: 'grade',
                    key: 'grade',
                    width: '20%'
                },
                {
                    title: '培训队伍',
                    dataIndex: 'team',
                    key: 'team',
                    width: '20%'
                },
                {
                    title: '起始时间',
                    dataIndex: '',
                    key: 'ysysj',
                    width: '15%',
                    render: (text, record) => {
                        return (
                            <span>{moment(record.startdate).format("YYYY-MM-DD HH:mm:ss")}</span>
                        )
                    }
                },
                {
                    title: '详情',
                    dataIndex: '',
                    key: 'xq',
                    width: '10%',
                    render: (text, record) => (
                        <span><Link to={"#"} className="table_a">查看详情</Link></span>
                    )
                }
            ], trainList = this.state.trainList,
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无数据',
            }, loading = this.state.data_loading;
        return (
            <Layout className="rescue-list">
                <Header style={{height: 'auto', padding: 0}}><Head background="#3F89C1" height={104}
                                                                   history={this.props.history}/></Header>
                <Content className="rl_content">
                    <Table className="table" size="middle" locale={locale} columns={columns} style={{height: '100%'}}
                           dataSource={trainList} loading={loading}
                           scroll={{ y: 'calc(100% - 46px)' }}
                           title={() => <div className="table_title">培训资讯列表</div>}
                           pagination={{
                               total: trainList.length,
                               pageSize: 20,
                               showTotal: (total, range) => `总数: ${total}`
                           }}

                    />
                </Content>
                {/*<Footer style={{padding: 0}}><Foote/></Footer>*/}
            </Layout>
        );
    }
}

export default TrainList;



// WEBPACK FOOTER //
// ./src/routes/TrainList.jsx